import React, { useEffect, useState } from "react";

export default function BlogSection() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await fetch(
          "https://easylearne.com/wp-json/acf/v3/pages/7"
        );
        const data = await res.json();
        const acf = data?.acf || {};

        const formattedBlogs = [
          {
            id: 1,
            title: acf.blog_1_title,
            tag: acf.blog_1_tag,
            image: acf.blog_1_image,
            link: acf.blog_1_link,
          },
          {
            id: 2,
            title: acf.blog_2_title,
            tag: acf.blog_2_tag,
            image: acf.blog_2_image,
            link: acf.blog_2_link,
          },
          {
            id: 3,
            title: acf.blog_3_title,
            tag: acf.blog_3_tag,
            image: acf.blog_3_image,
            link: acf.blog_3_link,
          },
        ].filter(b => b.title); // safety check

        setBlogs(formattedBlogs);
      } catch (err) {
        console.error("Blog fetch error:", err);
      }
    };

    fetchBlogs();
  }, []);

  return (
    <div className="container bg-white py-12 px-12">
      <h2 className="text-3xl font-bold text-center text-gray-900 mb-10">
        Our Blog
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
        {blogs.map((b, index) => (
          <a
            key={b.id || index}
            href={b.link}
            className="block bg-white rounded-2xl shadow-md hover:shadow-xl transition overflow-hidden border"
          >
            {/* Image Section */}
            <div className="relative w-full h-48">
              <img
                src={b.image}
                alt={b.title}
                className="w-full h-full object-cover"
              />

              {/* Badge */}
              <span className="absolute top-3 right-3 bg-blue-500 text-white text-xs font-semibold px-3 py-1 rounded-full shadow">
                {b.tag}
              </span>

              {/* Overlay Title */}
              <div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-black/70 to-transparent p-4">
                <p className="text-white font-bold text-lg leading-snug">
                  {b.title}
                </p>
              </div>
            </div>

            {/* Below Title */}
            <div className="px-4 py-4 text-gray-800 font-semibold text-sm">
              {b.title}
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
